{
    "users": {
        "22": {
            "name": "Anatoly",
            "description": "Solana dude",
            "socials": [
                {
                    "handle": "aeyakovenko",
                    "type": "Twitter"
                },
                {
                    "handle": "aeyakovenko",
                    "type": "GitHub"
                }
            ]
        },
        "23": {
            "name": "Austin Federa",
            "description": "Head of Communication at Solana Labs",
            "socials": [
                {
                    "handle": "Austin_Federa",
                    "type": "Twitter"
                }
            ]
        },
        "14": {
            "name": "Benno",
            "description": "Neodyme Co-Founder \u0026 Security Researcher"
        },
        "29": {
            "name": "Carl",
            "description": "Solana Labs: Sports enthusiast",
            "socials": [
                {
                    "handle": "Carlin",
                    "type": "GitHub"
                }
            ]
        },
        "11": {
            "name": "Daniel Kilimnik",
            "description": "Neodyme Co-Founder \u0026 Security Researcher",
            "socials": [
                {
                    "handle": "D_K_Dev",
                    "type": "Twitter"
                },
                {
                    "handle": "kilimnik",
                    "type": "GitHub"
                },
                {
                    "handle": "d-kilimnik",
                    "type": "LinkedIn"
                }
            ]
        },
        "21": {
            "name": "Dom",
            "description": "Head of BD Solana",
            "socials": [
                {
                    "handle": "Thedhkt",
                    "type": "Twitter"
                },
                {
                    "handle": "Scriptrunner2049",
                    "type": "GitHub"
                }
            ]
        },
        "10": {
            "name": "Hendrik Hofstadt",
            "description": "Neodyme Co-Founder \u0026 Security Researcher",
            "socials": [
                {
                    "handle": "hendrikhofstadt",
                    "type": "Twitter"
                }
            ]
        },
        "9": {
            "name": "Ilias",
            "description": "Neodyme Co-Founder \u0026 Security Researcher",
            "socials": [
                {
                    "handle": "A2nkF_",
                    "type": "Twitter"
                },
                {
                    "handle": "A2nkF",
                    "type": "GitHub"
                }
            ]
        },
        "8": {
            "name": "Jasper",
            "description": "Neodyme Co-Founder \u0026 Security Researcher",
            "socials": [
                {
                    "handle": "buffoon-of-spades",
                    "type": "GitHub"
                }
            ]
        },
        "30": {
            "name": "Jeff",
            "description": "Solana Labs: Software and Food enthusiast",
            "socials": [
                {
                    "handle": "Jeffwashington",
                    "type": "GitHub"
                }
            ]
        },
        "24": {
            "name": "Jon",
            "description": "Solana Labs: Yoga, but don’t look too much",
            "socials": [
                {
                    "handle": "Joncinque",
                    "type": "LinkedIn"
                },
                {
                    "handle": "Joncinque",
                    "type": "GitHub"
                }
            ]
        },
        "31": {
            "name": "Jordan",
            "description": "Solana Labs: Drinking enthusiast",
            "socials": [
                {
                    "handle": "jordansexton",
                    "type": "GitHub"
                },
                {
                    "handle": "jordaaash",
                    "type": "Twitter"
                }
            ]
        },
        "12": {
            "name": "Karla",
            "description": "Neodyme Co-Founder \u0026 Security Researcher",
            "socials": []
        },
        "5": {
            "name": "Leopold Schabel",
            "description": "Neodyme Co-Founder \u0026 Security Researcher",
            "socials": [
                {
                    "handle": "leolukde",
                    "type": "Twitter"
                }
            ]
        },
        "17": {
            "name": "Lisa Heidmann",
            "description": "Security Researcher",
            "socials": []
        },
        "4": {
            "name": "Felipe Custodio",
            "description": "Neodyme Co-Founder \u0026 Security Researcher",
            "socials": [
                {
                    "handle": "_localo_",
                    "type": "Twitter"
                },
                {
                    "handle": "OlfillasOdikno",
                    "type": "GitHub"
                },
                {
                    "handle": "UCFOC9a1ilr-cIdVCxuWC5nw",
                    "type": "YouTube"
                }
            ]
        },
        "7": {
            "name": "Marius",
            "description": "Neodyme Co-Founder \u0026 Security Researcher",
            "socials": [
                {
                    "handle": "DeeJayBro",
                    "type": "GitHub"
                }
            ]
        },
        "26": {
            "name": "Mvines",
            "description": "Solana Labs",
            "socials": [
                {
                    "handle": "Mvines",
                    "type": "GitHub"
                },
                {
                    "handle": "Mvines",
                    "type": "LinkedIn"
                }
            ]
        },
        "1": {
            "name": "Neodyme",
            "description": "Neodyme offers deep-dive technical audits and trainings. Additionally, we conduct independent research in various domains.",
            "socials": [
                {
                    "handle": "Neodyme",
                    "type": "Twitter"
                },
                {
                    "handle": "neodyme-labs",
                    "type": "GitHub"
                }
            ]
        },
        "33": {
            "name": "Neon",
            "description": "Take the best from two chains",
            "socials": [
                {
                    "handle": "Neonlabsorg",
                    "type": "GitHub"
                },
                {
                    "handle": "Neonlabsorg",
                    "type": "Twitter"
                }
            ]
        },
        "15": {
            "name": "Nico Gründel",
            "description": "Neodyme Co-Founder \u0026 Security Researcher",
            "socials": [
                {
                    "handle": "CarryWorm",
                    "type": "Twitter"
                },
                {
                    "handle": "CherryWorm",
                    "type": "GitHub"
                }
            ]
        },
        "2": {
            "name": "Patrick Reich",
            "description": "Neodyme Co-Founder \u0026 Security Researcher",
            "socials": [
                {
                    "handle": "Managarrmr",
                    "type": "Twitter"
                },
                {
                    "handle": "Managarmrr",
                    "type": "GitHub"
                },
                {
                    "handle": "patrick-reich-38b42319a",
                    "type": "LinkedIn"
                }
            ]
        },
        "27": {
            "name": "Sakridge",
            "description": "Solana Labs",
            "socials": [
                {
                    "handle": "sakridge",
                    "type": "GitHub"
                }
            ]
        },
        "3": {
            "name": "Sebastian Fritsch",
            "description": "Neodyme Co-Founder \u0026 Security Researcher",
            "socials": [
                {
                    "handle": "sintemal",
                    "type": "GitHub"
                },
                {
                    "handle": "sebastian-fritsch-9a7686198",
                    "type": "LinkedIn"
                }
            ]
        },
        "6": {
            "name": "Simon Klier",
            "description": "Neodyme Co-Founder \u0026 Security Researcher",
            "socials": [
                {
                    "handle": "BoredPerson",
                    "type": "GitHub"
                },
                {
                    "handle": "simon-klier-629685198",
                    "type": "LinkedIn"
                }
            ]
        },
        "28": {
            "name": "Starry",
            "description": "Solana Labs",
            "socials": [
                {
                    "handle": "Jstarry",
                    "type": "GitHub"
                },
                {
                    "handle": "Jstrry",
                    "type": "Twitter"
                }
            ]
        },
        "16": {
            "name": "Thomas Lambertz",
            "description": "Neodyme Co-Founder \u0026 Security Researcher",
            "socials": [
                {
                    "handle": "t_lambertz",
                    "type": "Twitter"
                },
                {
                    "handle": "tlambertz",
                    "type": "GitHub"
                }
            ]
        },
        "13": {
            "name": "Tobias Madl",
            "description": "Neodyme Co-Founder \u0026 Security Researcher",
            "socials": [
                {
                    "handle": "tobias-madl",
                    "type": "LinkedIn"
                },
                {
                    "handle": "gcm-explo1t",
                    "type": "GitHub"
                }
            ]
        },
        "25": {
            "name": "Trent",
            "description": "Solana Labs",
            "socials": [
                {
                    "handle": "t-nelson",
                    "type": "GitHub"
                }
            ]
        }
    }
}
